import { render, staticRenderFns } from "./boardShipment.vue?vue&type=template&id=0e4fa360&"
import script from "./boardShipment.vue?vue&type=script&lang=js&"
export * from "./boardShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QBtnDropdown,QCard,QCardSection,QSelect,QIcon,QSeparator,QCardActions,QBtn,QInput,QCheckbox} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QBtnDropdown,QCard,QCardSection,QSelect,QIcon,QSeparator,QCardActions,QBtn,QInput,QCheckbox}, component.options.components || {})
